module.exports = __webpack_public_path__ + "static/media/2.f68d8a0b.png";